import { API_URLs } from "../../../utilities/API_URLs";
import { Http } from "../../../utilities/axios/http";

/**
 * TEAM MANAGEMENT SERVICE
 */
export class TeamManagementService {
  static createTeam = async (value: any) => {
    try {
      return await Http.post(
        API_URLs.operations.teamManagement.postTeam,
        value
      );
    } catch (error) {
      return error;
    }
  };

  static getAllTeamsCommercial = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.teamManagement.getCommercialTeam,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllTeamsCabotage = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.teamManagement.getCabotageTeam,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getTeamById = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.operations.teamManagement.getOneTeam}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static updateTeam = async (value: any) => {
    const { id, ...rest } = value;
    try {
      return await Http.put(
        `${API_URLs.operations.teamManagement.postTeam}/${id}`,
        rest
      );
    } catch (error) {
      return error;
    }
  };

  static deleteTeam = async (id: string | number) => {
    try {
      return await Http.delete(
        API_URLs.operations.teamManagement.deleteTeam,
        id
      );
    } catch (error) {
      return error;
    }
  };
}

/**
 * SALE OPERATION SERVICE
 */

export class CommercialOperation {
  static getAllOperations = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.commercialOperation.getOperations,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllOperationsForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.commercialOperation.getOperationsForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllOperationsShiftingForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.commercialOperation.getOperationsShiftingForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllModelListForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.commercialOperation.getAllModelList,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneOperation = async (id: number, params?: any) => {
    try {
      return await Http.get(
        `${API_URLs.operations.commercialOperation.getOneOperations}/${id}`,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static createOperations = async (value: any) => {
    try {
      return await Http.post(
        API_URLs.operations.commercialOperation.createOperation,
        value
      );
    } catch (error) {
      return error;
    }
  };
  static addManifestoFiles = async (value: any) => {
    try {
      return await Http.post(
        API_URLs.operations.commercialOperation.createOperations,
        value
      );
    } catch (error) {
      return error;
    }
  };

  static updateOperations = async (value: any) => {
    try {
      return await Http.patch(
        API_URLs.operations.commercialOperation.updateOperations,
        value
      );
    } catch (error) {
      return error;
    }
  };

  static deleteOperation = async (id: number) => {
    try {
      return await Http.delete(
        API_URLs.operations.commercialOperation.deleteOperations,
        id
      );
    } catch (error) {
      return error;
    }
  };
}
/**
 * CABOTAGE OPERATION SERVICE
 */

export class CabotageOperation {
  static getAllOperations = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.cabotageOperation.getOperations,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllOperationsForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.cabotageOperation.getOperationsForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllOperationsShiftingForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.cabotageOperation.getOperationsShiftingForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getAllModelListForSelect = async (params: any) => {
    try {
      return await Http.get(
        API_URLs.operations.cabotageOperation.getAllModelList,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneOperation = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.operations.cabotageOperation.getOneOperations}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static createOperations = async (value: any) => {
    try {
      return await Http.post(
        API_URLs.operations.cabotageOperation.createOperations,
        value
      );
    } catch (error) {
      return error;
    }
  };

  static updateOperations = async (value: any) => {
    try {
      return await Http.patch(
        API_URLs.operations.cabotageOperation.updateOperations,
        value
      );
    } catch (error) {
      return error;
    }
  };

  static deleteOperation = async (id: number) => {
    try {
      return await Http.delete(
        API_URLs.operations.cabotageOperation.deleteOperations,
        id
      );
    } catch (error) {
      return error;
    }
  };
}

export class PlanningService {
  static getOneModel = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.operations.planning.getOneModel}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static savePlanning = async (data: any) => {
    const { id, ...rest } = data;
    try {
      return await Http.put(
        API_URLs.operations.planning.savePlanning?.replace("{id}", id),
        rest
      );
    } catch (error) {
      return error;
    }
  };

  static getMaterialByPlanning = async (id: string, params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.planning.getMaterialForPlanning.replace("{id}", id),
        params
      );
    } catch (error) {
      return error;
    }
  };

  static patchMaterialByPlanning = async (id: string, data: any) => {
    try {
      return await Http.put(
        API_URLs.operations.planning.getMaterialForPlanning.replace("{id}", id),
        data
      );
    } catch (error) {
      return error;
    }
  };
}

export class ManifestoService {
  static getAllMouvement = async (url: string, params?: any) => {
    try {
      return await Http.get(url, params);
    } catch (error) {
      return error;
    }
  };
}

export class PointingService {
  static getAllMouvement = async (url: string, params?: any) => {
    try {
      return await Http.get(url, params);
    } catch (error) {
      return error;
    }
  };
}

export class ContraryReserveService {
  static getAllMouvement = async (url: string, params?: any) => {
    try {
      return await Http.get(url, params);
    } catch (error) {
      return error;
    }
  };
}

export class OvertimeWork {
  static getAllWorks = async (
    operationId: number,
    teamId: number,
    params?: any
  ) => {
    try {
      return await Http.get(
        `${API_URLs.operations.salesOperations.overtimeWork.getworks}/${operationId}/${teamId}`,
        params
      );
    } catch (error) {
      return error;
    }
  };
}

export class TimesheetOperation {
  static getAllTimesheet = async (
    operationId: number,
    teamId: number,
    params?: any
  ) => {
    try {
      return await Http.get(
        `${API_URLs.operations.salesOperations.timesheet.getTimeSheet}/${operationId}/${teamId}`,
        params
      );
    } catch (error) {
      return error;
    }
  };
}

export class ExecutionReportService {
  static getAllExecutionReport = async (url: string, params?: any) => {
    try {
      return await Http.get(`${url}/dockside-execution-report`, params);
    } catch (error) {
      return error;
    }
  };
}

export class ActivityService {
  static getAllActivities = async (params?: any) => {
    try {
      return await Http.get(API_URLs.operations.activity.get, params);
    } catch (error) {
      return error;
    }
  };

  static getActivityById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.operations.activity.getOne}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static createActivity = async (data: any) => {
    try {
      return await Http.post(API_URLs.operations.activity.post, data);
    } catch (error) {
      return error;
    }
  };

  static updateActivity = async (data: any) => {
    try {
      return await Http.patch(API_URLs.operations.activity.get, data);
    } catch (error) {
      return error;
    }
  };

  static deleteActivity = async (id: number) => {
    try {
      return await Http.delete(API_URLs.operations.activity.get, id);
    } catch (error) {
      return error;
    }
  };
}

export class OperationFoldersService {
  static getFolders = async (id: string, params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.operationFolders.get.replace("{id}", id),
        params
      );
    } catch (error) {
      return error;
    }
  };

  static createFolder = async (data: any) => {
    try {
      return await Http.post(API_URLs.operations.operationFolders.post, data);
    } catch (error) {
      return error;
    }
  };

  static updateFolder = async (id: number, data: any) => {
    try {
      return await Http.put(
        `${API_URLs.operations.operationFolders.put}/${id}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
}

export class ShiftingOperationsService {
  static getAllShiftingOperations = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.shifting.shiftingOperations,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getShiftingOperationsById = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.operations.shifting.shiftingOperations}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static updateShiftingOperations = async (id: number, data: any) => {
    try {
      return await Http.put(
        `${API_URLs.operations.shifting.shiftingOperations}/${id}`,
        data
      );
    } catch (error) {
      return error;
    }
  };

  static deleteShiftingOperations = async (id: number) => {
    try {
      return await Http.delete(
        API_URLs.operations.shifting.shiftingOperations,
        id
      );
    } catch (error) {
      return error;
    }
  };
}
export class HatchCoverService {
  static getAllHatchCovers = async (params?: any) => {
    try {
      return await Http.get(API_URLs.operations.shifting.hatchCover, params);
    } catch (error) {
      return error;
    }
  };

  static getHatchCoverById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.operations.shifting.hatchCover}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static updateHatchCover = async (data: any) => {
    try {
      return await Http.patch(API_URLs.operations.shifting.hatchCover, data);
    } catch (error) {
      return error;
    }
  };

  static deleteHatchCover = async (id: number) => {
    try {
      return await Http.delete(API_URLs.operations.shifting.hatchCover, id);
    } catch (error) {
      return error;
    }
  };
}

export class WaitingTimeService {
  static getWaitingTimeById = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.operations.shifting.waitingTime}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static getWaitingTimeList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.operations.shifting.waitingTime, params);
    } catch (error) {
      return error;
    }
  };

  static updateWaitingTime = async (data: any) => {
    try {
      return await Http.patch(API_URLs.operations.shifting.waitingTime, data);
    } catch (error) {
      return error;
    }
  };

  static deleteWaitingTime = async (id: number) => {
    try {
      return await Http.delete(API_URLs.operations.shifting.waitingTime, id);
    } catch (error) {
      return error;
    }
  };
}

export class ConfrontationService {
  static getConfrontationList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.operations.confrontation.get, params);
    } catch (error) {
      return error;
    }
  };

  static getConfrontationTypeSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.confrontation.selectType,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getConfrontationStatusSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.operations.confrontation.selectStatus,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getConfrontationById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.operations.confrontation.get}/${id}`);
    } catch (error) {
      return error;
    }
  };
}

export class DetailService {
  static getStaffs = async (id: number, params?: any) => {
    try {
      return await Http.get(`${API_URLs.operations.detail.getStaff}/${id}`);
    } catch (error) {
      return error;
    }
  };
}
